import { squashToStartD } from './squash-date';

export function getPresentWeekMonday(): Date {
  const prevMonday = new Date();
  prevMonday.setDate(prevMonday.getDate() - ((prevMonday.getDay() + 6) % 7));
  return prevMonday;
}

export function getPresentWeekSunday(): Date {
  const presentWeekMonday = getPresentWeekMonday();
  const presentWeekSunday = new Date(presentWeekMonday);
  presentWeekSunday.setDate(presentWeekSunday.getDate() + 6);
  return presentWeekSunday;
}

export function getLastWeekSunday(): Date {
  const presentWeekMonday = getPresentWeekMonday();
  const lastWeekSunday = new Date(presentWeekMonday);
  lastWeekSunday.setDate(lastWeekSunday.getDate() - 1);
  return lastWeekSunday;
}

export function getLastWeekMonday(): Date {
  const presentWeekMonday = getPresentWeekMonday();
  const lastWeekMonday = new Date(presentWeekMonday);
  lastWeekMonday.setDate(lastWeekMonday.getDate() - 7);
  return lastWeekMonday;
}

export function getYesterday(): Date {
  const today = squashToStartD(new Date());
  const yesterday = new Date(today.setDate(today.getDate() - 1));
  return yesterday;
}
